import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { DatePipe, registerLocaleData } from '@angular/common';
import ru from '@angular/common/locales/ru';
import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppComponent } from './app.component';
import { DateComponent } from './components/date/date.component';
import { HeaderComponent } from './components/header/header.component';
import { LangsComponent } from './components/langs/langs.component';
import { TypeRaceComponent } from './components/type-race/type-race.component';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SplitButtonModule } from 'primeng/splitbutton';
import { TooltipModule } from 'primeng/tooltip';
import { ToastModule } from 'primeng/toast';
import { MenuModule } from 'primeng/menu';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { IntlPhoneInputModule } from './shared/components/intl-phone-input/intl-phone-input.module';

import { AppRoutingModule } from './app-routing.module';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ProfileService } from './services/profile.service';
import { RaceAuthModule } from './modules/race-auth/race-auth.module';
import { ProgressService } from './services/progress.service';
import { RaceService } from './services/race.service';
import { SettingsService } from './services/settings.service';
import { LoaderService } from './services/loader.service';
import { LoaderComponent } from './components/loader/loader.component';
import { HttpInterceptorService } from './services/http-interceptor.service';
import { SharedPipesModule } from './shared-pipes.module';
import { TrackerService } from './services/tracker.service';

registerLocaleData(ru, 'ru-ru');

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    DateComponent,
    LangsComponent,
    TypeRaceComponent,
    LoaderComponent
  ],
  imports: [
    SharedPipesModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    CalendarModule,
    ButtonModule,
    TooltipModule,
    DialogModule,
    RaceAuthModule,
    ConfirmDialogModule,
    RadioButtonModule,
    SplitButtonModule,
    AppRoutingModule,
    ToastModule,
    ConfirmPopupModule,
    ProgressSpinnerModule,
    IntlPhoneInputModule,
    MenuModule,
    HttpClientModule
  ],
  providers: [
    ProfileService, 
    DialogService, 
    MessageService,
    RaceService, 
    LoaderService,
    ProgressService,
    SettingsService,
    TrackerService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true
    }
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }

